export default __webpack_public_path__ + "static/media/Junge-mit-Hund.61a828ca.png";